module.exports = __webpack_public_path__ + "static/media/boost-exposure.441e35d4.svg";